// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3YvCO","content":"Consent_content__9E5BL","footer":"Consent_footer__3Q-7O"};